export default __webpack_public_path__ + "static/media/file.2bb6b4f0.svg";